import useSWR from 'swr'
import API from '../../../utils/api'
import { INDEXPIRCE, TRADEAPI_URL } from '../../constants/TRADEAPIKEYS'
import { useToken } from '../auth/token'

let swrData: any = []
let swrData2: any = []
let mutateData: any = []

export function useIndexPrice(ep_id: number) {
	const { data: token } = useToken()
	let KEY: string | null = INDEXPIRCE + '?ep_id=' + ep_id
	if (ep_id == null || ep_id === undefined) KEY = null

	const { data, mutate } = useSWR<any>(
		KEY,
		async () => {
			if (swrData[ep_id]) return swrData[ep_id]

			const response = await API.get(
				INDEXPIRCE + '?ep_id=' + ep_id,
				token + '',
				{},
				false,
				TRADEAPI_URL
			)
			swrData[ep_id] = response.result
			return swrData[ep_id]
		},
		{ revalidateOnFocus: false, revalidateIfStale: false, dedupingInterval: 5000 }
	)
	
	swrData2[ep_id] = data
	mutateData[ep_id] = mutate

	return {
		data,
		mutate: (value?: any, epid?: number) => {
			try {
				if (value !== undefined) {
					swrData[epid ? epid : ep_id] = value
					swrData2[epid ? epid : ep_id] = value
				}
				if (epid && typeof mutateData[epid] == 'function') {
					mutate()
					return mutateData[epid]()
				} else {
					return mutate()
				}
			} catch (e) {
				return mutate()
			}
		},
		getPrice: (epid?: number) => {
			try {
				if (epid) {
					return swrData2[epid]?.[0]?.price || 0
				} else {
					return swrData2[ep_id]?.[0]?.price || 0
				}
			} catch (e) {
				return 0
			}
		},
	}
}
